import React from 'react';

export default (
	<svg
		width="23"
		height="23"
		viewBox="0 0 23 23"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M21.8535 21.1465V11.3535H22.8535V22.8535H11.3535V21.8535H21.1465L0 0.707031L0.707031 0L21.8535 21.1465Z"
			fill="#664800"
		/>
	</svg>
);
